import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.nav.sidebar');
import { HostListener, OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-component-nav-sidebar',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.nav.sidebar/view.scss */
:host {
  display: contents;
}

.brand-area {
  min-height: 6.3rem;
}

.brand-link img {
  filter: drop-shadow(0 4px 8px rgba(5, 150, 105, 0.08));
  transition: transform 180ms ease;
}

.brand-link:hover img {
  transform: translateY(-1px) scale(1.015);
}

.account-card {
  border: 1px solid rgba(167, 243, 208, 0.78);
  box-shadow: 0 10px 24px rgba(6, 78, 59, 0.06);
}

.account-card-main {
  background: radial-gradient(circle at 100% 0%, rgba(52, 211, 153, 0.15), transparent 6rem), linear-gradient(145deg, #ecfdf5, #f6fdf9);
}

.sidebar-nav {
  scrollbar-color: #d7e3dd transparent;
  scrollbar-width: thin;
}

.sidebar-section-label {
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.sidebar-link {
  border: 1px solid transparent;
  min-height: 2.35rem;
  position: relative;
  transition: background-color 160ms ease, border-color 160ms ease, color 160ms ease, transform 160ms ease;
}

.sidebar-link:hover {
  border-color: rgba(167, 243, 208, 0.72);
  transform: translateX(2px);
}

.sidebar-link.is-active {
  background: linear-gradient(135deg, #065f46, #047857) !important;
  border-color: rgba(4, 120, 87, 0.82);
  box-shadow: 0 7px 16px rgba(6, 78, 59, 0.16);
}

.sidebar-link.is-active::after {
  background: #6ee7b7;
  border-radius: 9999px;
  content: "";
  height: 0.3rem;
  position: absolute;
  right: 0.65rem;
  width: 0.3rem;
}

@media (prefers-reduced-motion: reduce) {
  .brand-link img,
  .sidebar-link {
    transition: none;
  }
  .brand-link:hover img,
  .sidebar-link:hover {
    transform: none;
  }
}`],
})
export class ComponentNavSidebarComponent implements OnInit {
    private dashboardWorkspaces: string[] = [
        'dashboard',
        'cases',
        'clients',
        'ipo',
        'kipris',
        'notices',
        'laws',
        'media',
        'forms',
        'adminSupport',
        'accessStatus',
        'intakeConsultations',
        'intakeConsultationDetail'
    ];

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
    }

    @HostListener('document:click')
    public clickout() {
        this.service.status.toggle('navbar', true);
    }

    @HostListener('window:dashboard:workspace-changed')
    @HostListener('window:popstate')
    public async refreshActiveState() {
        await this.service.render();
    }

    public dashboardUrl(workspace: string) {
        if (workspace === 'dashboard') return '/dashboard';
        return `/dashboard?workspace=${workspace}`;
    }

    public async openDashboardWorkspace(workspace: string, event: any) {
        if (event?.button !== 0 || event?.metaKey || event?.ctrlKey || event?.shiftKey || event?.altKey) return;
        if (location.pathname !== '/dashboard') return;

        event.preventDefault();
        const target = this.normalizeWorkspace(workspace) || 'dashboard';
        history.pushState({ workspace: target }, '', this.dashboardUrl(target));
        window.dispatchEvent(new CustomEvent('dashboard:navigate', { detail: { workspace: target } }));
        this.service.status.toggle('navbar', true);
        await this.service.render();
    }

    public workspaceClass(workspace: string) {
        if (this.currentDashboardWorkspace() === workspace) {
            return 'sidebar-link is-active group flex gap-x-2 items-center rounded-lg bg-emerald-900 px-2.5 py-2 text-[13px] font-semibold text-white';
        }
        return 'sidebar-link group flex gap-x-2 items-center rounded-lg px-2.5 py-2 text-[13px] font-medium text-slate-600 hover:bg-emerald-50 hover:text-emerald-950';
    }

    public tenantRoleLabel() {
        const role = String(this.service?.auth?.session?.tenant_role || '').toUpperCase();
        if (role === 'TENANT_ADMIN' || role === 'TENANT_OWNER') return '소속관리자';
        return '사용자';
    }

    public isTenantAdmin() {
        const role = String(this.service?.auth?.session?.tenant_role || '').toUpperCase();
        return role === 'TENANT_ADMIN' || role === 'TENANT_OWNER';
    }

    public membersLinkClass() {
        if (location.pathname === '/members') {
            return 'sidebar-link is-active group flex gap-x-2 items-center rounded-lg bg-emerald-900 px-2.5 py-2 text-[13px] font-semibold text-white';
        }
        return 'sidebar-link group flex gap-x-2 items-center rounded-lg px-2.5 py-2 text-[13px] font-medium text-slate-600 hover:bg-emerald-50 hover:text-emerald-950';
    }

    private currentDashboardWorkspace() {
        if (location.pathname !== '/dashboard') return '';
        const params = new URLSearchParams(location.search);
        if (params.has('workspace')) {
            return this.normalizeWorkspace(params.get('workspace') || '');
        }

        const fromHash = this.normalizeWorkspace(location.hash.replace('#', ''));
        return fromHash || 'dashboard';
    }

    private normalizeWorkspace(workspace: string) {
        if (this.dashboardWorkspaces.indexOf(workspace) >= 0) return workspace;
        return '';
    }
}

export default ComponentNavSidebarComponent;